import React, { useState, useContext, useRef } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import colors from "../../config/colors";
import NtActivityIndicator from "../../components/NtActivityIndicator";
import UserContext from "../../context/UserContext";
import NtModalUnactiveButton from "../../components/NtModalUnactiveButton";
import NtModalActiveButton from "../../components/NtModalActiveButton";
import NtModalInputField from "../../components/NtModalInputField";
import { createCallingRate } from "../../api/billing";
import Logger from "../../common/utils/Logger";
import { parseError } from "@ntconnect/framework/pbx";
import NtModalError from "../../components/NtModalError";
import NtModalTitle from "../../components/NtModalTitle";
import NtModalSubtitle from "../../components/NtModalSubtitle";
import NtModalInputTitle from "../../components/NtModalInputTitle";
import NtTabController from "../../components/NtTabController";
import currencydata from "../data/currencydata";

function NtCallingRatesTariffNewForm({ tariff, item, onCancel, onCreate }) {
  const [loading, setLoading] = useState(false);
  const [destination, setDestination] = useState("");
  const [cost, setCost] = useState("");
  const [price, setPrice] = useState("");
  const [name, setName] = useState("");
  const [currency, setCurrency] = useState(currencydata[0]);
  const [error, setError] = useState(null);

  const context = useContext(UserContext);

  const isRequiredFields = () => {
    return destination && cost && price && name && currency;
  };

  const handleCreate = async () => {
    setLoading(true);

    setError(null);

    const params = {
      destination: destination,
      cost: cost,
      price: price,
      name: name,
      currency: currency?.id,
    };

    const response = await createCallingRate(tariff, params);

    Logger("Calling Cards add", response);

    if (response.ok) {
      if (onCreate) {
        onCreate();
      }
    } else {
      setError(parseError(response));
    }

    setLoading(false);
  };

  const renderCurrencyType = (containerStyle) => {
    return (
      <View style={containerStyle}>
        <NtModalInputTitle style={{ marginLeft: 4 }}>
          Currency
        </NtModalInputTitle>

        <NtTabController
          containerStyle={{ marginTop: 4 }}
          options={currencydata}
          selection={currency}
          onPress={(item) => {
            setCurrency(item);
          }}
        />
      </View>
    );
  };

  return (
    <View style={styles.container}>
      <NtModalTitle>Add new Special Rate</NtModalTitle>
      <NtModalSubtitle style={[{ marginTop: 4 }]}>
        Create special rates for "
        <NtText style={{ fontWeight: "bold" }}>{tariff}</NtText>" calling cards
      </NtModalSubtitle>

      <NtModalInputField
        containerStyle={{ marginTop: 15 }}
        title={"Dial Prefix *"}
        placeholder={"Dial Prefix"}
        value={destination}
        setValue={(text) => setDestination(text)}
      />

      <NtModalInputField
        containerStyle={{ marginTop: 15 }}
        title={"Cost *"}
        placeholder={"Cost"}
        value={cost}
        setValue={(text) => setCost(text)}
      />

      <NtModalInputField
        containerStyle={{ marginTop: 15 }}
        title={"Price *"}
        placeholder={"Price"}
        value={price}
        setValue={(text) => setPrice(text)}
      />

      <NtModalInputField
        containerStyle={{ marginTop: 15 }}
        title={"Name *"}
        placeholder={"Name"}
        value={name}
        setValue={(text) => setName(text)}
      />

      {renderCurrencyType({ marginTop: 15 })}

      <NtModalError error={error} containerStyle={{ marginTop: 6 }} />

      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          marginTop: 25,
        }}
      >
        {loading && (
          <NtActivityIndicator
            color={colors.blue}
            size="small"
            containerStyle={{ marginRight: 25 }}
          />
        )}

        <NtModalUnactiveButton title={"Cancel"} onPress={onCancel} />

        <NtModalActiveButton
          containerStyle={{ marginLeft: 15 }}
          title={"Create"}
          onPress={() => {
            if (isRequiredFields()) {
              handleCreate();
            }
          }}
          enabled={isRequiredFields()}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minWidth: 500,
    maxWidth: 500,
    padding: 15,
  },
  fieldTitle: {
    fontSize: 14,
    fontWeight: "700",
    color: colors.darker,
  },
});

export default NtCallingRatesTariffNewForm;
